import find from 'lodash/find';
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import DOMUtils from '@livongo/utils/dom';
import StorageUtils from '@livongo/utils/storage';
import Backend from 'i18next-chained-backend';
import HttpApi from 'i18next-http-backend';
import languages from './languages';

const BUILD_TAG_KEY = 'cp-build-tag';
const BUILD_TAG =
    window?.process?.env?.BUILD_TAG ?? process.env.BUILD_TAG ?? 'dev';
const LANG_COOKIE = 'cp-lang';

export const defaultLang = find(languages, 'default').code;

export const getLanguage = () => {
    return StorageUtils.get({key: LANG_COOKIE}) || defaultLang;
};

export const setLanguage = language => {
    DOMUtils.el('html').lang = language;
};

export default function init({isDev, debug, lang}) {
    const userBuildTag = StorageUtils.get({key: BUILD_TAG_KEY});
    const appNamespace = 'app';
    const commonNamespace = 'common';
    // Cache buster – MUST be build-time stable
    const translationCacheBuster = BUILD_TAG;
    const backends = [HttpApi];
    const backendOptions = [
        {
            loadPath: `${
                isDev ? '/' : process.env.ASSET_PATH || '/'
            }locales/{{lng}}/{{ns}}.json`,
            queryStringParams: {
                v: translationCacheBuster,
            },
        },
    ];

    // Clear session storage when build changes
    if (!isDev && BUILD_TAG !== userBuildTag) {
        StorageUtils.clear('session');
        StorageUtils.set({key: BUILD_TAG_KEY, value: BUILD_TAG});
    }

    setLanguage(lang);

    return i18n
        .use(Backend)
        .use(initReactI18next)
        .init({
            debug,
            backend: {
                backends,
                backendOptions,
            },
            ns: [appNamespace, commonNamespace],
            defaultNS: appNamespace,
            fallbackNS: commonNamespace,
            lng: lang,
            fallbackLng: defaultLang,
            interpolation: {
                escapeValue: false,
            },
            react: {
                useSuspense: false,
            },
        });
}
